<fc-general-modal
  [baseId]="baseId"
  [form]="form"
  [fcModalItemContext]="fcModalItemContext"
  (saveForm)="save()"
  (cancelForm)="onCancel()"
>
  <div [formGroup]="form">
    <div class="flex-row-generic">
      <div class="flex-item-three-columns">
        <div class="form-group">
          <label
            for="{{ baseId }}-external-id"
            translate
          >ID</label>
          <input
            id="{{ baseId }}--external-id"
            class="form-control"
            [ngClass]="{ error: showErrors(externalIdControl, isSubmitted), 'required': isRequired(externalIdControl) }"
            [maxlength]="fcListValidation.validations.ExternalID.MaxLength"
            type="text"
            formControlName="externalId"
          />
          <div
            *ngIf="showErrors(externalIdControl, isSubmitted)"
            id="{{ baseId }}-warning-text-name"
            class="incorrect-input"
            translate
          >
            {{ externalIdControl.errors | fcListValidation : 'ID' }}
          </div>
        </div>
      </div>
      <div class="flex-item-three-columns">
        <div class="form-group modal-checkboxes">
          <mat-checkbox
            id="{{ baseId }}-inactive-checkbox"
            formControlName="inactive"
            translate
          > Inactive
          </mat-checkbox>
        </div>
      </div>
    </div>

    <div class="flex-row-generic">
      <div class="flex-item-three-columns">
        <div class="form-group">
          <label
            class="label-type"
            for="{{ baseId }}-checkboxes-name"
            translate>
            Type
          </label>
          <mat-radio-group class="radio-group responsible-party-group"
                           (change)="onChangeRadioBtn($event)">
            <mat-radio-button [value]="responsiblePartyEnum.CORPORATION">
              Corporation
            </mat-radio-button>
            <mat-radio-button [checked]="true"
                              [value]="responsiblePartyEnum.PERSON">
              Person
            </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
    </div>
    <div class="flex-row-generic">

      <mat-tab-group animationDuration="0ms" mat-align-tabs="start" class="tabs-default full-modal-tabs" [disableRipple]="true">
        <ng-container [ngSwitch]="selectedType">
          <mat-tab label="Contact Info">
            <ng-container *ngSwitchCase="responsiblePartyEnum.PERSON">
              <div class="flex-item-three-columns" *ngIf="fcModalItemContext.mode === fcItemModalModeEnum.New">
                <button class="btn btn-light btn-flush-left existing-person-btn"
                        type="button"
                        (click)="onSelectExistingPerson()"
                >Select an Existing Person
                </button>
              </div>
              <fc-person-list
                [baseId]="baseId + 'person'"
                [form]="personFormGroup"
                [isSubmitted]="isSubmitted"
                [listItem]="listItem.Person"
                [itemContext]="fcModalItemContext"
              ></fc-person-list>
            </ng-container>
            <ng-container *ngSwitchCase="responsiblePartyEnum.CORPORATION">

              <div class="flex-item-three-columns" *ngIf="fcModalItemContext.mode === fcItemModalModeEnum.New">
                <button class="btn btn-light btn-flush-left existing-person-btn"
                        type="button"
                        (click)="onSelectExistingPerson()"
                >Select an Existing Corporation
                </button>
              </div>

              <fc-corporation-list
                [baseId]="baseId + 'corporation'"
                [form]="corporationFormGroup"
                [listItem]="listItem.Corporation"
                [isSubmitted]="isSubmitted"
                [itemContext]="fcModalItemContext"
              ></fc-corporation-list>
              <div class="form-group full-control">
                <!-- Notes Control -->
                <label
                  for="{{ baseId }}-notes"
                  translate
                >Notes</label>
                <textarea
                  class="form-control"
                  [ngClass]="{ error: showErrors(notesControl, isSubmitted), 'required': isRequired(notesControl) }"
                  id="{{ baseId }}-notes"
                  [maxlength]="fcListValidation.validations.Notes.MaxLength"
                  formControlName="notes"
                  rows="3"
                >
                  </textarea>
                <div
                  *ngIf="showErrors(notesControl, isSubmitted)"
                  id="{{ baseId }}-warning-text-notes"
                  class="incorrect-input"
                  translate
                >
                  {{ notesControl.errors | fcListValidation : 'Notes' }}
                </div>
                <!-- Notes Control -->
              </div>
            </ng-container>
          </mat-tab>
        </ng-container>

        <mat-tab label="Employment"
                 *ngIf="responsiblePartyEnum.PERSON === selectedType && fcModalItemContext.mode === fcItemModalModeEnum.Modify">

          <div class="button-plus-new">
            <button
              id="fnd-configuration-new"
              class="btn btn-light btn-flush-left"
              (click)="onNewClick()"
              translate
              type="button"
            >
              + New
            </button>
          </div>
          <table class="table emds-table table-sticky-header table-striped table-selected-row">
            <thead>
            <tr>
              <th translate>Employer</th>
              <th translate>Occupation</th>
              <th translate>Industry</th>
              <th translate>Start Date</th>
              <th translate>End Date</th>
              <th translate>Department</th>
              <th class="column-width" translate>Action</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let tableItem of listItem.PersonEmployerRelation">
              <td>{{ tableItem?.EmployerName}}</td>
              <td>{{ tableItem?.OccupationName}}</td>
              <td>{{ tableItem?.IndustryName}}</td>
              <td>{{ tableItem?.StartDate?.Date | date: 'M/d/YYYY' }}</td>
              <td>{{ tableItem?.EndDate?.Date | date: 'M/d/YYYY' }}</td>
              <td>{{ tableItem?.Department }}</td>
              <td>
                <div class="emds icons-container">
                  <a role="button" title="edit" (click)="onEditTableItem($event, tableItem)">
                    <mat-icon class="material-icons">edit</mat-icon>
                  </a>
                  <a role="button" title="delete" (click)="onDeleteTableItem($event, tableItem)">
                    <mat-icon class="material-icons">delete</mat-icon>
                  </a>
                </div>
              </td>
            </tr>
            </tbody>
          </table>

        </mat-tab>
        <mat-tab label="Collection">
          <span class="tab-label" translate>Collection</span>
        </mat-tab>
        <mat-tab label="Statement">
          <span class="tab-label" translate>Statement</span>
        </mat-tab>
        <mat-tab label="CHC">
          <span class="tab-label" translate>CHC</span>
        </mat-tab>

      </mat-tab-group>

    </div>
  </div>

</fc-general-modal>
